var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("validation-observer", { ref: "form", attrs: { novalidate: "" } }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _c("section-title", {
            attrs: {
              "container-class": "tag-badge-main-info mt-4 mb-4",
              content: "III. Expectativa y Observaciones Generales",
              icon: "fas fa-clipboard-list-check"
            }
          }),
          !_vm.isReadOnly
            ? _c("validation-provider", {
                attrs: { rules: "required" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function({ errors }) {
                        return [
                          _c("custom-text-area", {
                            attrs: {
                              "count-classes": [
                                "d-block",
                                "small-counter",
                                "text-right"
                              ],
                              "custom-error-msg": "Campo requerido",
                              disabled: _vm.isReadOnly,
                              error: errors[0],
                              label:
                                "Meta de estudio, adiestramiento o empleo expresada por el/la estudiante:",
                              maxlength: 5000,
                              "show-char-count": ""
                            },
                            model: {
                              value: _vm.model.studyGoal,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "studyGoal", $$v)
                              },
                              expression: "model.studyGoal"
                            }
                          })
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  522686964
                )
              })
            : _c("div", { staticClass: "d-flex flex-column" }, [
                _c(
                  "label",
                  {
                    staticClass: "text-muted",
                    staticStyle: { "font-size": "14px" }
                  },
                  [
                    _vm._v(
                      " Meta de estudio, adiestramiento o empleo expresada por el/la estudiante: "
                    )
                  ]
                ),
                _c("span", [_vm._v(_vm._s(_vm.model.studyGoal))])
              ])
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _c("section-title", {
            attrs: {
              "container-class": "tag-badge-main-info mt-4 mb-4",
              content: "IV. Observaciones Generales",
              icon: "fas fa-clipboard-list-check"
            }
          }),
          !_vm.isReadOnly
            ? _c("validation-provider", {
                attrs: { rules: "required" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function({ errors }) {
                        return [
                          _c("custom-text-area", {
                            attrs: {
                              "count-classes": [
                                "d-block",
                                "small-counter",
                                "text-right"
                              ],
                              "custom-error-msg": "Campo requerido",
                              disabled: _vm.isReadOnly,
                              error: errors[0],
                              label:
                                "Entrevista, Primera Cita, Segunda Cita y Otras Intervenciones:",
                              maxlength: 5000,
                              "show-char-count": ""
                            },
                            model: {
                              value: _vm.model.generalObservations,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "generalObservations", $$v)
                              },
                              expression: "model.generalObservations"
                            }
                          })
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  1425848803
                )
              })
            : _c("div", { staticClass: "d-flex flex-column" }, [
                _c(
                  "label",
                  {
                    staticClass: "text-muted",
                    staticStyle: { "font-size": "14px" }
                  },
                  [
                    _vm._v(
                      " Entrevista, Primera Cita, Segunda Cita y Otras Intervenciones: "
                    )
                  ]
                ),
                _c("span", [_vm._v(_vm._s(_vm.model.generalObservations))])
              ])
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _c("section-title", {
            staticClass: "mt-3",
            attrs: {
              content: "Conducta Observada Durante la Evaluación:",
              "has-line": ""
            }
          }),
          _c("observed-behavior-selector", {
            ref: "observedBehaviorSelector",
            attrs: {
              "is-read-only": _vm.isReadOnly,
              types: _vm.types,
              validated: _vm.formValidated
            },
            model: {
              value: _vm.model.options,
              callback: function($$v) {
                _vm.$set(_vm.model, "options", $$v)
              },
              expression: "model.options"
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }